import React, { memo, useEffect, useState } from 'react'
import ReactECharts from 'echarts-for-react'

import * as _ from 'lodash'
import { _formatDate3 } from 'utils'
import { numberFormat } from 'utils'

const appUrl = `${process.env.REACT_APP_ALGO_API_URL}`

var emphasisStyle = {
  itemStyle: {
    shadowBlur: 10,
    shadowColor: 'rgba(0,0,0,0.3)',
  },
}

function usePrevious(value) {
  const ref = React.useRef()

  useEffect(() => {
    ref.current = value
  }, [value]) // Only re-run if value changes

  return ref.current
}

function ChartMuaBanRong(props) {
  const abortController = new AbortController()
  const DEFAULT_OPTION = {
    grid: { top: 8, right: 45, bottom: 20, left: 15 },
    color: ['#0FC786', '#F5465C'],
    legend: {
      show: false,
      data: ['bar', 'bar2'],
      left: '10%',
    },
    xAxis: {
      //   type: 'category',
      boundaryGap: false,
      axisTick: {
        alignWithLabel: true,
        length: 3,
      },
      axisLabel: {
        color: '#83817C',
        fontSize: 8,
        // formatter: function (value, index) {
        //   const arr = value.split(':');
        //   return arr[0] + ':' + arr[1];
        // },
        borderColor: '#ECECEC',
        showMinLabel: true,
        showMaxLabel: true,
      },
      data: [],
      // show: false,
      axisLine: { onZero: true },
      splitLine: { show: false },
      splitArea: { show: false },
    },
    yAxis: {
      type: 'value',
      show: true,
      position: 'right',
      alignTicks: true,
      splitNumber: 6,
      splitLine: {
        show: true,
        lineStyle: {
          type: 'dashed',
          color: '#4E4D62',
          dashOffset: 10,
          opacity: 0.3,
        },
      },
      axisLabel: {
        formatter: (val) =>
          `${Math.abs(val) >= 1000000 ? val / 1000000 : Math.abs(val) >= 1000 ? val / 1000 : val}${
            Math.abs(val) >= 1000000 ? 'M' : val >= 1000 ? 'K' : ''
          }`,
        color: '#83817C',
        fontSize: 8,
        showMinLabel: false,
        margin: 15,
      },
    },
    series: [
      {
        name: 'Mua ròng',
        type: 'bar',
        stack: 'one',
        emphasis: emphasisStyle,
        itemStyle: {
          color: '#0FC786',
        },
        data: [],
      },
      {
        name: 'Bán ròng',
        type: 'bar',
        stack: 'one',
        emphasis: emphasisStyle,
        itemStyle: {
          color: '#F5465C',
        },
        data: [],
      },
    ],
    tooltip: {
      // show: false,
      trigger: 'item',
      // formatter: '{a} <br/>{b}: {c}',
      formatter: function (value, index) {
        // console.log(value)
        return `${value.seriesName} : ${numberFormat(
          Math.abs(value.value),
          2
        )} tỷ`
      },
    },
  }

  const [option, setOption] = useState(DEFAULT_OPTION)

  const { symActive } = props

  const preSymActive = usePrevious(symActive)

  useEffect(() => {
    return () => {
      abortController.abort()
    }
  }, [])

  useEffect(() => {
    if (symActive && !_.isEqual(symActive, preSymActive)) {
      _handleLoadDataStock()
    }
  }, [symActive])

  function _handleLoadDataStock() {
    let _param = ''
    switch (symActive) {
      case 'VNINDEX':
        _param = 'HOSE'
        break
      case 'HNX':
      case 'HNXIndex':
      case 'HNXINDEX':
        _param = 'HNX'
        break

      case 'UPCOMINDEX':
      case 'UPCOM':
        _param = 'UPCOM'
        break

      default:
        _param = symActive
        break
    }
    fetch(
      appUrl + 'pbapi/api/stockBoard/index/getForeignInvestorsBuy/' + _param,
      {
        signal: abortController.signal,
      }
    )
      .then((response) => response.json())
      .then((res) => {
        _mapDataToState(res.data)
      })
      .catch((error) => {
      })
  }

  function _mapDataToState(dt) {
    const newOption = _.cloneDeep(option)
    let xAxisData = []
    let data1 = []
    let data2 = []

    // log(dt)

    for (let index = 0; index < dt.length; index++) {
      if (index > 9) continue

      const element = dt[index]
      xAxisData.push(_formatDate3(element.tradeDate))
      data1.push(element.totalFBuyValue / 1000000000)
      data2.push(-element.totalFSellValue / 1000000000)
    }

    // log(dt)

    newOption.xAxis.data = xAxisData.reverse()

    newOption.series[0].data = data1.reverse()
    newOption.series[1].data = data2.reverse()

    setOption(newOption)
  }

  return (
    <ReactECharts
      option={option}
      style={{
        height: '100px',
        width: `100%`,
      }}
    />
  )
}

export default memo(ChartMuaBanRong)
